/**
* 车辆管理
*/
<template>
  <div style="margin:20px">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>车辆管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="车辆编号:">
        <el-input size="small" v-model="formInline.car_id" placeholder="输入车辆编号"></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input size="small" v-model="formInline.car_number" placeholder="输入车牌号"></el-input>
      </el-form-item>
      <el-form-item label="车辆型号">
        <el-select size="small" v-model="formInline.car_type" clearable @click="onClick()" placeholder="请选择车辆型号">
          <el-option v-for="item in cartype" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item>
        <el-select size="small" v-model="formInline.car_type" placeholder="请选择">
          <el-option v-for="type in car_type" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      

      <el-form-item>
        <el-button size="small" :inline="true" @click="importCar">导入车辆数据</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%">
      <el-table-column align="center" header-align="center" prop="id" label="编号" width="80"></el-table-column>
      <el-table-column prop="car_id" label="车辆编号" width="150" header-align="center" align="center"></el-table-column>
      <el-table-column prop="name" label="名称" width="200" header-align="center" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="car_number" label="车牌号" width="100" header-align="center" align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_type" label="车辆型号" width="100" header-align="center" align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_brand" label="车辆品牌" width="100" header-align="center" align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_voltage" label="额定电压" header-align="center" align="center" width="100"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_motor_power" label="电机功率" width="100" align="center" header-align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_max_speed" label="最高车速" width="100" align="center" header-align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_load_mass" label="额定载质量" width="120" align="center" header-align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_curb_weight" label="整备质量" width="100" align="center" header-align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="manufacturing_date" label="制造日期" width="150" align="center" header-align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_color" label="车身颜色" width="100" align="center" header-align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" label="车辆状态" width="100" align="center" header-align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#e5e5e5"
            @change="changeSwitch(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="data_source" label="数据来源" width="150" align="center" header-align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="car_comment" label="备注" width="150" align="center" header-align="center"
        show-overflow-tooltip></el-table-column>

      <el-table-column fixed="right" label="操作" width="200" align="center" header-align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.driver_name == null" @click="openDriver(scope.row)">选择司机</el-button>
         
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="50%" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <div style="padding-right: 5%">
        <el-form class="demo-form-inline" label-width="
        120px" :model="editForm" ref="editForm" :rules="rules">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="车辆编号" prop="car_id">
                <el-input disabled size="small" v-model="editForm.car_id" auto-complete="off" placeholder="请输入车辆编号"></el-input>
              </el-form-item>
              <el-form-item label="车辆名称" prop="name">
                <el-input disabled size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入车辆编号"></el-input>
              </el-form-item>

              <el-form-item prop="car_type" label="车辆型号">
                <el-select size="small" v-model="editForm.car_type" clearable @click="onClickEdit()"
                  placeholder="请选择车辆型号">
                  <el-option v-for="item in cars_type" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车牌号" prop="car_number">
                <el-input disabled size="small" v-model="editForm.car_number" auto-complete="off" placeholder="请输入车辆编号">
                </el-input>
              </el-form-item>
              <el-form-item label="车身颜色" prop="car_color">
                <el-input disabled size="small" v-model="editForm.car_color" auto-complete="off" placeholder="请输入车身颜色">
                </el-input>
              </el-form-item>
              <el-form-item label="车辆品牌" prop="car_brand">
                <el-input disabled size="small" v-model="editForm.car_brand" auto-complete="off" placeholder="请输入车辆品牌">
                </el-input>
              </el-form-item>
              <el-form-item label="额定电压(V)" prop="car_voltage">
                <el-input disabled size="small" v-model="editForm.car_voltage" auto-complete="off" placeholder="请输入额定电压(V)">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电池容量(Kwh)" prop="car_battery_capacity">
                <el-input disabled size="small" v-model="editForm.car_battery_capacity" auto-complete="off"
                  placeholder="请输入电池容量(Kwh)"></el-input>
              </el-form-item>
              <el-form-item label="电机功率(Kw)" prop="car_motor_power">
                <el-input disabled size="small" v-model="editForm.car_motor_power" auto-complete="off" placeholder="请输入电机功率(Kw)">
                </el-input>
              </el-form-item>
              <el-form-item label="最高车速(Km/h)" prop="car_max_speed">
                <el-input disabled size="small" v-model="editForm.car_max_speed" auto-complete="off" placeholder="请输入最高车速(Km/h)">
                </el-input>
              </el-form-item>
              <el-form-item label="额定载质量(kg)" prop="car_load_mass">
                <el-input disabled size="small" v-model="editForm.car_load_mass" auto-complete="off" placeholder="请输入额定载质量(kg)">
                </el-input>
              </el-form-item>

              <el-form-item label="整备质量(kg)" prop="car_curb_weight">
                <el-input disabled size="small" v-model="editForm.car_curb_weight" auto-complete="off" placeholder="请输入整备质量(kg)">
                </el-input>
              </el-form-item>
              <el-form-item label="制造日期" prop="manufacturing_date">
                <el-input disabled size="small" v-model="editForm.manufacturing_date" auto-complete="off" placeholder="请输入制造日期">
                </el-input>
              </el-form-item>
              <el-form-item label="备注" prop="manufacturing_date">
                <el-input  size="small" type="textarea" v-model="editForm.remarks" auto-complete="off" placeholder="请输入备注">

                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-left: 10%">
            <el-button size="mini" type="primary" @click="submitFormEdit('editForm')">提交</el-button>
            <el-button size="mini" @click="closeDialog('editForm')">取消</el-button>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <!-- 选择司机 -->
    <el-dialog width="30%" title="选择司机" :visible.sync="dialogFormVisible" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form>
        <el-form-item label="选择司机">
          <el-select size="small" v-model="value" clearable @click="onClickdriver()" placeholder="请选择">
            <el-option v-for="item in drivers" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="margin-top:10px">
        <el-button size="small" type="primary" @click="submitAddDriver">确 定</el-button>
        <el-button size="small" @click="closeDialog()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 导入车辆 -->
    <el-dialog title="车辆数据" :visible.sync="outerVisible" width="70%" :close-on-click-modal="false">
      <el-form :inline="true" :model="importInline">
        <el-form-item label="车辆编号">
          <el-input size="small" v-model="importInline.car_id" placeholder="输入车辆编号"></el-input>
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input size="small" v-model="importInline.car_number" placeholder="输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="车辆型号">
          <el-select size="small" v-model="importInline.car_type" clearable @click="onClickImport()"
            placeholder="输入车辆型号">
            <el-option v-for="item in car_types" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchCar">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="addImport">确 定</el-button>
          <el-button size="small" @click="outerVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="gridData" @selection-change="handleSelectionChange" ref="multipleTable" row-key="id">
        <el-table-column width="50" type="selection" reserve-selection></el-table-column>
        <el-table-column align="center" width="50" property="id" label="ID"></el-table-column>
        <el-table-column align="center" width="100" property="car_id" label="车辆编号"></el-table-column>
        <el-table-column align="center" width="200" property="name" label="名称"></el-table-column>
        <el-table-column align="center" width="100" property="car_number" label="车牌号"></el-table-column>
        <el-table-column align="center" width="150" property="car_type" label="车辆型号"></el-table-column>
       
        <el-table-column width="400" align="center" property="car_comment" label="备注"></el-table-column>
      </el-table>
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagetwo.currentPage" :page-sizes="[5, 10, 15, 25, 50, 100]" :page-size="pagetwo.pageSize"
          background :pager-count="5" layout="total, sizes, prev, pager, next, jumper" :total="pagetwo.total">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>

  import Pagination from "../../components/Pagination";
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        // addFormVisible: false,
        dialogTableVisible: false,
        dialogFormVisible: false,
        outerVisible: false,
        title: "添加",
        driver_open: true,
        // driver_shut: false,
        idsval: [],
        ids: [],
        //选择车辆型号
        cartype: [],
        cars_type: [],
        car_types: [],
        //选择司机
        drivers: [],
        //导入线路数据
        gridData: [],
        value: "",
        //编辑
        editForm: {
          id: "",
          car_id: "",
          name: "",
          car_number: "",
          car_type: "",
          car_voltage: "",
          car_motor_power: "",
          car_max_speed: "",
          car_load_mass: "",
          car_curb_weight: "",
          manufacturing_date: "",
          car_color: "",
          status: "",
          data_source: "",
          car_battery_capacity: "",
          car_brand: "",
          car_comment: ""
        },

        // rules表单验证
        rules: {
          car_id: [
            { required: true, message: "请输入车辆编号", trigger: "blur" },
            {
              pattern: /^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,20}$/,
              message: "请输入正确的车辆编号,如：WMIRC221121100004",
              trigger: "blur"
            }
          ],
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          car_number: [
            { required: true, message: "请输入车牌号", trigger: "blur" },
            {
              pattern: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Z]{1}[A-Z0-9]{5}$/,
              message: "请输入正确的车牌号,如：鲁C88888",
              trigger: "blur"
            }
          ],
          car_type: [
            { required: true, message: "请选择车辆型号", trigger: "change" }
          ],
          car_voltage: [
            { required: true, message: "请输入额定电压", trigger: "blur" },
            {
              pattern: /^\d+$|^\d+[.]?\d+$/,
              message: "请输入数字,如48",
              trigger: "blur"
            }
          ],
          car_load_mass: [
            { required: true, message: "请输入额定载质量", trigger: "blur" },
            {
              pattern: /^\d+$|^\d+[.]?\d+$/,
              message: "请输入数字,如48",
              trigger: "blur"
            }
          ],
          car_motor_power: [
            { required: true, message: "请输入电机功率", trigger: "blur" },
            {
              pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
              message: "请输入数字,如4.8",
              trigger: "blur"
            }
          ],
          car_max_speed: [
            { required: true, message: "请输入最高车速", trigger: "blur" },
            {
              pattern: /^\d+$|^\d+[.]?\d+$/,
              message: "请输入数字,如48",
              trigger: "blur"
            }
          ],
          car_load_mass: [
            { required: true, message: "请输入额定载质量", trigger: "blur" },
            {
              pattern: /^\d+$|^\d+[.]?\d+$/,
              message: "请输入数字,如48",
              trigger: "blur"
            }
          ],
          car_color: [
            { required: true, message: "请输入车身颜色", trigger: "blur" }
          ],
          car_brand: [
            { required: true, message: "请输入车辆品牌", trigger: "blur" }
          ],
          car_curb_weight: [
            { required: true, message: "请输入整备质量", trigger: "blur" },
            {
              pattern: /^\d+$|^\d+[.]?\d+$/,
              message: "请输入数字,如48",
              trigger: "blur"
            }
          ],
          car_battery_capacity: [
            { required: true, message: "请输入电池容量", trigger: "blur" },
            {
              pattern: /^\d+$|^\d+[.]?\d+$/,
              message: "请输入数字,如48",
              trigger: "blur"
            }
          ],
          manufacturing_date: [
            { required: true, message: "请输入制造时间", trigger: "blur" }
          ]
        },
        formInline: {
          car_id: "",
          car_type: "",
          driver_name: "",
          car_number: "",
          page: 1,
          limit: 10
        },
        importInline: {
          car_id: "",
          car_type: "",
          car_number: "",
          page: 1,
          limit: 10
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        // 导入车辆分页参数
        pagetwo: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      };
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata();
      this.onClick();
      this.onClickEdit();
      this.onClickImport();
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取车辆列表
      getdata(parm) {
        this.loading = true;
        // 模拟数据
        let res = {
          data: [
            {
              id: "1",
              car_id: "1111",
              name: "11111111",
              car_number: "",
              car_type: "",
              car_brand: "",
              car_voltage: "10v",
              car_motor_power: "100w",
              car_max_speed: "30km/h",
              car_load_mass: "1000kg",
              car_curb_weight: "111",
              manufacturing_date: "121233",
              car_color: "红色",
              status: "",
              data_source: "11111",
              car_comment: "1111",
              driver_name: "11"
            }
          ]
        };
        this.loading = false;
        this.listData = res.data;
      },
     
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage;
        this.formInline.limit = parm.pageSize;
        this.getdata();
      },
      callcar() {
        this.importInline.page = this.pagetwo.currentPage;
        this.importInline.limit = this.pagetwo.pageSize;
        this.getimport();
      },

      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata();
      },
      searchCar() {
        this.importInline.page = 1;
        this.getimport();
      },
      //选择车辆类型
      onClick() {
    
      },

      //导入车辆信息
      importCar() {
        this.outerVisible = true;
        this.importInline.car_id = "";
        this.importInline.car_type = "";
        this.importInline.car_number = "";
        this.importInline.page = 1;
        this.getimport();
        this.toggleRowSelect();
      },
      

      //修改状态
      changeSwitch(row) {
      
      },
      //显示编辑界面
      handleEdit(row) {
  
        this.editForm = {};
        this.editFormVisible = true;
   
      },
      //编辑车辆类型
      onClickEdit() {
     
      },
      // 编辑页面保存方法
      submitFormEdit(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
        
          } else {
            return false;
          }
        });
      },
      //导入搜索车辆型号
      onClickImport() {
     
      },
      //导入车辆id
      handleSelectionChange(val) {
        this.idsval = [];
        for (let i in val) {
          //去重以免发生意外的push
          if (!this.idsval.includes(val[i])) {
            this.idsval.push(val[i]);
          }
        }
      },
      toggleRowSelect() {
        var that = this;
        that.$nextTick(() => {
          if (that.$refs.multipleTable) {
            that.$refs.multipleTable.clearSelection();
          }
        });
      },
      //导入数据
      addImport() {
        this.outerVisible = false;
        for (var i = 0; i < this.idsval.length; i++) {
          this.ids.push(this.idsval[i].id);
        }
        var strs = this.ids.join(",");
        get_import_data_add(strs).then(res => {
          if (res["code"] === 0) {
            this.getdata();
            this.$message.success(res["message"]);
            this.ids = [];
          } else {
            this.$message.error(res["message"]);
          }
        });
      },
      //显示选择司机
      openDriver(row) {
        this.dialogFormVisible = true;
        this.value = "";
        window.localStorage.setItem("car", row.id);
        this.onClickdriver();
      },
      //解绑司机
      shutDriver(row) {
        get_unbind_driver(row.id).then(res => {
          if (res["code"] === 0) {
            this.getdata();
            this.$message.success(res["message"]);
          } else {
            this.$message.error(res["message"]);
          }
        });
      },
      //选择司机
      onClickdriver() {
     
      },
      // 选择司机页面保存方法
      submitAddDriver() {
        this.dialogFormVisible = false;
      
      },
      // 删除
      deleteUser(row) {
        this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning"
        })
          .then(() => {
     
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      handleSizeChange(val) {
        this.pagetwo.pageSize = val;
        this.callcar();
      },
      handleCurrentChange(val) {
        this.pagetwo.currentPage = val;
        this.callcar();
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.dialogFormVisible = false;
        this.editFormVisible = false;
        this.$refs[formName].resetFields();
      }
    }
  };
</script>

<style lang=css scoped>
  .user-search {
    margin-top: 30px;
    width: 100%;
    height: 80px;
  }

  .userRole {
    width: 100%;
  }

  .mask {
    background-color: #000;
    opacity: 0.3;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .pop {
    background-color: #fff;

    position: fixed;
    top: 100px;
    left: 300px;
    width: calc(100% - 600px);
    height: calc(100% - 200px);
    z-index: 2;
  }

  .btn {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid blue;
    padding: 4px 12px;
  }
</style>


// WEBPACK FOOTER //
// src/views/vehicle_mn/Vehicle_mn.vue